import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import messages_tr from "../translations/tr";
import messages_en from "../translations/en";

const allMessages = {
    'tr': messages_tr,
    'en': messages_en
};

function mapStateToProps(state) {
    const locale = state.currentLanguage;
    const messages = allMessages[locale];
    return {
        locale,
        messages
    };
}

export default connect(mapStateToProps)(IntlProvider);